define.alias("shared/components/shared/address-fields/item", "calendar/components/shared/address-fields/item");